/**
 * @file BoardroomTable.ts
 * @brief Boardroom's own icon: a meeting table that listens (was lucide Presentation).
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/BoardroomTable.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * DES 09-10-2026: DES's own drawing ("APPS BRANDING/SVG/boardroomnewicon.svg"):
 * pill table, three bars on one base line (middle tallest), chairs, at
 * stroke 2 so it is as big as the icons beside it.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const BoardroomTable = createLucideIcon("BoardroomTable", [
  ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "6", key: "table" }],
  ["path", { d: "M8.5 12v2", key: "wave-l" }],
  ["path", { d: "M12 10v4", key: "wave-c" }],
  ["path", { d: "M15.5 12v2", key: "wave-r" }],
  ["path", { d: "M6 2h4", key: "chair-tl" }],
  ["path", { d: "M14 2h4", key: "chair-tr" }],
  ["path", { d: "M6 22h4", key: "chair-bl" }],
  ["path", { d: "M14 22h4", key: "chair-br" }],
]);

export default BoardroomTable;
